import { Routes } from '@angular/router';

import { AcknowledgementType } from 'src/app/core/enums/acknowledgement-type.enum';

import { legalAcknowledgementResolver } from '../../resolvers/legal-acknowledgement.resolver';
import { LegalAcknowledgementsStore } from '../../store/legal-acknowledgements.store';

export const termsRoutes: Routes = Object.values(AcknowledgementType).map(
  (type) => ({
    path: `terms/${type.toLowerCase()}`,
    resolve: { legalAcknowledgement: legalAcknowledgementResolver },
    providers: [LegalAcknowledgementsStore],
    loadComponent: () =>
      import('./legal-acknowledgement-page.component').then(
        (m) => m.LegalAcknowledgementPageComponent,
      ),
    data: {
      acknowledgementType: type,
      pageName: `Legal - ${type}`,
    },
  }),
);
